import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import {
  Article,
  ConseilDeliceService,
} from '../../services/conseil-delice.service';
import { LoaderComponent } from '../../shared/loader/loader.component';

@Component({
  selector: 'app-conseil-delice',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe, LoaderComponent],
  templateUrl: './conseil-delice.component.html',
  styleUrls: ['./conseil-delice.component.css'],
})
export class ConseilDeliceComponent implements OnInit {
  currentPage = 1;
  pageSize = 10;
  totalPages = 1;

  isLoading = false;
  error: string | null = null;
  articles: Article[] = [];

  // ⚡ Champs pour le POST
  nameOrg: string = 'Pubeducanet';
  position: string = 'Conseil';

  constructor(private service: ConseilDeliceService) {}

  ngOnInit(): void {
    this.loadConseil(this.currentPage);
  }

loadConseil(page: number): void {
  if (!this.nameOrg || !this.position) {
    this.error = 'Paramètres organisation ou position manquants.';
    return;
  }

  this.isLoading = true;
  this.error = null;

  this.service.getArticles(this.nameOrg, this.position, page, this.pageSize)
    .subscribe({
      next: (response) => {
        this.articles = response?.response || [];
        this.totalPages = Math.ceil(this.articles.length / this.pageSize) || 1;
        this.currentPage = page;
        this.isLoading = false;
        console.log('Articles chargés:', this.articles);
      },

      error: (err) => {
        console.error('Erreur lors du chargement des conseils:', err);
        this.error = 'Impossible de charger les conseils.';
        this.isLoading = false;
      }
    });
}


  get pageNumbers(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number) {
    if (this.isLoading || page < 1 || page > this.totalPages) return;
    this.loadConseil(page);
  }

  previousPage() {
    if (this.currentPage > 1) this.goToPage(this.currentPage - 1);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) this.goToPage(this.currentPage + 1);
  }
}
